import { Box, List, ListItem, Typography } from "@mui/material";
import DialogWrapper from "components/DialogWrapper";

const AttendanceInfo = (props) => {
  const { open, setOpen } = props;
  return (
    <DialogWrapper
      title="Important Attendance and Data Notes"
      open={open}
      setOpen={setOpen}
      width="md"
    >
      <Box sx={{ paddingBottom: 2, margin: 1, backgroundColor: '#f9f9f9', borderRadius: 2 }}>
        {/* <Typography variant="h6" component="h2" gutterBottom>

        </Typography> */}

        <List>
          <ListItem >
            1. Deleting a Holiday Permanently Clears Status History
            Warning: If you add a holiday entry and then subsequently delete it, the system will permanently remove all corresponding status information and associated data from the database. This includes any status that may have been stored for that date before the holiday was initially saved.
          </ListItem>
          <ListItem>
            2. Holiday Status Overrides All Attendance
            A Holiday designation always takes precedence over all other attendance entries (Present or Absent) for that specific day.
          </ListItem>
          {/* <ListItem>
            3. Aadhaar OTP Login (Single Factor Authentication)
          </ListItem> */}
        </List>
        <Typography variant="body1" gutterBottom>
          <span style={{ color: "red", fontWeight: "600" }} > Override Rule: </span>
          If a day is marked as a Holiday, this status will supersede any prior Present or Absent marking.
        </Typography>
        <Typography variant="body1" gutterBottom>
          <span style={{ color: "red", fontWeight: "600" }} > Overtime Calculation: </span>
          If an employee is marked Present on an officially designated Holiday, the final status will be recorded as Holiday Present, and this will be automatically calculated as overtime pay.
        </Typography>
      </Box>
    </DialogWrapper>
  )
}

export default AttendanceInfo